import { InjectionToken } from '@angular/core';

export interface IStripeConfig {
  apiKey: string;
  connectClientId: string;
}

export const NG_STRIPE_CONFIG: InjectionToken<IStripeConfig> =
  new InjectionToken('IStripeConfig');
